import React, { useEffect, useRef, useState } from "react";
import "./ManageProduct.scss";

import { MdAddBox } from "react-icons/md";
import { IoIosArrowRoundUp, IoMdAddCircleOutline } from "react-icons/io";
import { IoSearch } from "react-icons/io5";
import { FaCaretUp, FaList, FaLongArrowAltDown } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { IoGridSharp } from "react-icons/io5";
import { FaPlus, FaSquareCheck } from "react-icons/fa6";

import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import InputField from "../../../components/InputField/InputField";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addCategory } from "../../../api/categories";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import ProductItem from "./ProductItem";

import Papa from "papaparse";

import ROUTES from "../../../constants/routes";
import Loader from "../../../components/Loader/Loader";
import useUserIsAllowed from "../../../helpers/userAuthorized";
import {
  deleteExistingProduct,
  loadNextProducts,
  loadProductsIfNeeded,
  loadProductsWorthIfNeeded,
  updateLastParams,
  updateListStyle,
} from "../../../redux/features/products-slice";
import AddProduct from "../AddProduct/AddProduct";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";
import { addNewCategory } from "../../../redux/features/organization-slice";
import { deleteMultipleProducts } from "../../../api/products";
import SyncLoader from "../../../components/SyncLoader/SyncLoader";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useClickOutside } from "use-events";
import useOrganizationIsAllowed from "../../../helpers/organizationPrevillages";
import { updateOpenSubscriptionAd } from "../../../redux/features/subscription-slice";
import { LuSearchX } from "react-icons/lu";
import { updateNetworkStatus } from "../../../redux/features/home-slice";

const ManageProduct = () => {
  const { currentViewPort } = useViewPortDetector();
  const dispatch = useDispatch();
  const {
    id: organization_id,
    currency,
    categories,
  } = useSelector((state) => state.organizationReducer.value);

  const {
    products,
    worthData,
    lastParams,
    loading: loadingProducts,
    loadingNextPage,
    currentPage,
    lastPage,
    listStyle,
    loadingBackground,
    loadBackgroundFailed,
  } = useSelector((state) => state.productReducer.value);

  const { id: branch_id } = useSelector((state) => state.branchReducer.value);

  const orgIsAllowedToManageStock =
    useOrganizationIsAllowed("stock_management");

  const isAllowedToAddProduct = useUserIsAllowed("create_or_edit_products");
  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");

  const userIsAllowedToDeleteProduct =
    userIsAdministrator || userIsAllowedToManageInventory;

  const navigate = useNavigate();

  const [selectOptions, setSelectOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});
  const [serachKeyword, setSearchKeyword] = useState(lastParams?.keyword || "");
  const [debounceSerachKeyword, setDebounceSearchKeyword] = useState(
    lastParams?.keyword || ""
  );

  const [openAddCategory, setOpenAddCategory] = useState(false);

  const [selectedTab, setSelectedTab] = useState("");

  const [pageNumber, setPageNumber] = useState(currentPage || 1);
  const lastProductRef = useRef(null);

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [allowMultipleSelect, setAllowMultipleSelect] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedArray, setSelectedArray] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);

  const [openSortOptions, setOpenSortOptions] = useState(false);
  const [sortBy, setSortBy] = useState(lastParams?.sortBy || "created_at");
  const [sort, setSort] = useState(lastParams?.sort || "desc");

  const sortOptions = [
    {
      label: "Date",
      value: "created_at",
    },
    {
      label: "Price",
      value: "price",
    },
    {
      label: "A-Z",
      labelSecond: "Z-A",
      value: "name",
    },
    {
      label: "Stock",
      value: "current_stock",
    },
  ];

  const timerRef = useRef(null);

  useEffect(() => {
    return () => {
      dispatch(updateLastParams());
    };
  }, [dispatch]);

  const [productNotFound, setProductNotFound] = useState(null);

  useEffect(() => {
    if (debounceSerachKeyword && products?.length < 1) {
      setProductNotFound(`No product found for ${debounceSerachKeyword}`);
    }
  }, [debounceSerachKeyword, products]);

  useEffect(() => {
    if (products?.length === selectedArray?.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }

    if (allowMultipleSelect && selectedArray?.length < 1) {
      setTimeout(() => {
        setAllowMultipleSelect(false);
      }, 300);
    }

    if (allowMultipleSelect) {
      setSelectedProduct(null);
    }
  }, [products, selectedArray, allowMultipleSelect]);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedArray([]);
    } else {
      const tempArray = [];

      products?.forEach((item) => {
        tempArray.push(item?.id);
      });

      setSelectedArray(tempArray);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (
          entry.isIntersecting &&
          pageNumber < lastPage &&
          !loadingNextPage &&
          !loadingProducts
        ) {
          setPageNumber((prevPage) => prevPage + 1);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      }
    );

    const currentRef = lastProductRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [
    pageNumber,
    lastPage,
    loadingNextPage,
    loadingProducts,
    selectedArray,
    lastProductRef.current,
    products,
    debounceSerachKeyword,
    sort,
    sortBy,
  ]);

  useState(() => {
    setOpenAddCategory(false);
  }, [selectedTab]);

  const getCategoriesOptions = () => {
    let optionsData = [
      {
        label: "All Products",
        value: "",
      },
      {
        label: "Highlighted Products",
        value: "highlighted",
      },
    ];
    categories?.map((item) => {
      const option = {
        label: `${item?.name}`,
        value: item?.id,
      };
      optionsData.push(option);
    });

    optionsData.push({
      label: "Add Category",
      value: "add_category",
    });

    setSelectOptions(optionsData);
  };

  useEffect(() => {
    if (!selectedOption?.label && !loadingProducts) {
      const newSelectedOption = selectOptions?.find(
        (el) => el?.value === lastParams?.category
      );
      if (newSelectedOption) {
        setSelectedOption(newSelectedOption);
      } else {
        if (selectOptions?.length > 0) {
          setSelectedOption(selectOptions[0]);
        }
      }
    }
  }, [lastParams, selectOptions]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceSearchKeyword(serachKeyword);
    }, 500);

    return () => clearTimeout(handler);
  }, [serachKeyword]);

  useEffect(() => {
    if (selectedOption?.label) {
      dispatch(
        loadProductsIfNeeded({
          organization_id: organization_id,
          branch_id: branch_id,
          keyword: debounceSerachKeyword,
          category: selectedOption?.value || "",
          sort: sort,
          sortBy: sortBy,
        })
      );
      setSelectedProduct(null);
      setSelectedArray([]);
      setPageNumber(1);
    }
  }, [
    organization_id,
    branch_id,
    debounceSerachKeyword,
    selectedOption,
    sort,
    sortBy,
  ]);

  useEffect(() => {
    dispatch(
      loadProductsWorthIfNeeded({
        organization_id: organization_id,
        branch_id: branch_id,
      })
    );
  }, [organization_id, branch_id]);

  useEffect(() => {
    getCategoriesOptions();
  }, [categories]);

  useEffect(() => {
    if (pageNumber > currentPage) {
      dispatch(loadNextProducts({ page: pageNumber }));
    }
  }, [pageNumber]);

  const handleSelectItem = (item) => {
    const exists = selectedArray?.findIndex((el) => el === item?.id);

    if (exists === -1) {
      setSelectedArray((pre) => [...pre, item?.id]);
    } else {
      const tempArray = [...selectedArray];
      tempArray.splice(exists, 1);
      setSelectedArray(tempArray);
    }
  };

  const [isScrolling, setIsScrolling] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = (e) => {
    const currentScrollTop = e.target.scrollTop;

    setIsScrolling(currentScrollTop > lastScrollY);
    if (currentScrollTop !== lastScrollY) {
      handleMouseUp();
    }

    setLastScrollY(currentScrollTop);
  };

  const handleMouseDown = (item, touch) => {
    if (allowMultipleSelect) {
      if (!touch) {
        handleSelectItem(item);
      }
    } else {
      timerRef.current = setTimeout(() => {
        handleSelectItem(item);
        setAllowMultipleSelect(true);
      }, 500);
    }
  };

  const handleMouseUp = () => {
    clearTimeout(timerRef.current);
  };

  const handleSort = (el) => {
    if (sortBy === el?.value) {
      if (sort === "asc") {
        setSort("desc");
      } else {
        setSort("asc");
      }
    } else {
      setSortBy(el?.value);
    }
    // setOpenSortOptions(false);
  };

  const sortRef = useRef(null);

  useClickOutside([sortRef], () => {
    setOpenSortOptions(false);
  });

  useEffect(() => {
    if (loadingBackground) {
      dispatch(updateNetworkStatus({ status: "syncing" }));
    }
  }, [loadingBackground]);

  return (
    <>
      {loadingProducts && <Loader />}
      <div className="page-with-side-components">
        <div className="manage-products">
          <div className="desktop-navbar">
            <p>{ROUTES.manageProduct.title}</p>

            <div className="last-tag-svg">
              <p className="sort">
                Sort by {sortOptions?.find((el) => el.value === sortBy)?.label}
                <FaCaretUp
                  className={sort === "desc" ? "opposite" : ""}
                />
              </p>
              <BsThreeDotsVertical
                onClick={() => {
                  setOpenSortOptions((pre) => !pre);
                }}
              />
            </div>
          </div>
          <div
            className={`sort-by-options ${openSortOptions ? "active" : ""}`}
            ref={sortRef}
          >
            {sortOptions?.map((el, i) => {
              return (
                <p
                  className={sortBy === el.value ? "active" : ""}
                  onClick={() => {
                    handleSort(el);
                  }}
                >
                  {el.value === "name" && sort === "desc"
                    ? el?.labelSecond
                    : el.label}

                  <FaCaretUp
                    className={sort === "desc" ? "rotate" : ""}
                  />
                </p>
              );
            })}
          </div>

          <div className="topbar customPerPageTopBar">
            <div className="left">
              <CustomSelect
                options={selectOptions}
                value={selectedOption}
                register={() => {}}
                required={true}
                name="isHighlight"
                handleChange={(opt) => {
                  if (opt.value === "add_category") {
                    if (
                      userIsAdministrator ||
                      userIsAllowedToManageInventory ||
                      isAllowedToAddProduct
                    ) {
                      setOpenAddCategory(true);
                      setSelectedTab("");
                    } else {
                      toast.dismiss();
                      toast.info(
                        "You do not have sufficient permissions to perform this action. Please contact your administrator."
                      );
                    }
                  } else {
                    setSelectedOption(opt);
                  }
                }}
                reset={() => {}}
              />
            </div>
            <div className="middle">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setDebounceSearchKeyword(e.target.keyword.value);
                }}
                className="inputs"
              >
                <input
                  type="text"
                  name="keyword"
                  defaultValue={serachKeyword}
                  placeholder="Search."
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                />
                <button type="submit">
                  <IoSearch />
                </button>
              </form>
            </div>
            <div className="right">
              <p
                className="icon mobile-search-icon"
                onClick={() => {
                  if (selectedTab !== "search") {
                    setSelectedTab("search");
                  } else {
                    setSelectedTab("");
                  }
                }}
              >
                <IoSearch />
              </p>

              <p
                className="icon"
                onClick={() => {
                  if (listStyle === "list") {
                    dispatch(updateListStyle({ listStyle: "grid" }));
                  } else {
                    dispatch(updateListStyle({ listStyle: "list" }));
                  }
                  setSelectedTab("");
                }}
              >
                {listStyle !== "list" ? <FaList /> : <IoGridSharp />}
              </p>
              <p
                className="icon"
                onClick={() => {
                  if (isAllowedToAddProduct) {
                    if (selectedTab !== "import") {
                      setSelectedTab("import");
                    } else {
                      setSelectedTab("");
                    }
                  } else {
                    toast.dismiss();
                    toast.info(
                      "You do not have sufficient permissions to perform this action. Please contact your administrator."
                    );
                  }
                }}
              >
                <FiDownload />
              </p>
              <Link
                className="icon last-item mobile"
                to={ROUTES.addProduct.path}
                onClick={() => {
                  setSelectedTab("");
                }}
                id="tour-add-product"
              >
                <IoMdAddCircleOutline />
              </Link>
              <p
                className="icon last-item desktop"
                onClick={() => {
                  setSelectedTab("addProduct");
                  setOpenAddCategory(false);
                  setSelectedProduct(null);
                }}
                id="tour-add-product-desktop"
              >
                <IoMdAddCircleOutline />
              </p>
            </div>
          </div>

          <div
            className={`search-bar ${selectedTab === "search" ? "active" : ""}`}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setDebounceSearchKeyword(e.target.keyword.value);
              }}
              className="inputs"
            >
              <input
                type="text"
                name="keyword"
                defaultValue={serachKeyword}
                placeholder="Search."
                onChange={(e) => {
                  setSearchKeyword(e.target.value);
                }}
              />
              <button type="submit">
                <IoSearch />
              </button>
            </form>
          </div>

          {allowMultipleSelect && (
            <div
              className={`multiple-selection ${
                selectedTab === "search" ? "searchActive" : ""
              }`}
            >
              <div
                className={`left ${allowMultipleSelect ? "active" : ""}`}
                onClick={() => {
                  setAllowMultipleSelect((pre) => !pre);
                  setSelectedArray([]);
                  setSelectedProduct(null);
                }}
              >
                <span>
                  <FaSquareCheck />
                </span>
                <p>Multiple Select</p>
              </div>

              <div
                className={`right ${allowMultipleSelect ? "show" : ""} ${
                  selectAll ? "active" : ""
                }`}
                onClick={handleSelectAll}
              >
                <span>
                  <FaSquareCheck />
                </span>
                <p>Select All</p>
              </div>
            </div>
          )}

          <div
            className={`overallProductList container-wrapper manage-products-list ${
              products.length > 0 && "flexStart"
            } ${selectedTab === "search" ? "searchActive" : ""} ${
              allowMultipleSelect ? "" : "checkout-products"
            }`}
          >
            {products.length === 0 && (
              <div className="first-item">
                <Link className="mobile" to={ROUTES.addProduct.path}>
                  {productNotFound ? <LuSearchX /> : <MdAddBox />}
                </Link>
                <Link className="desktop" to={"#"}>
                  {productNotFound ? <LuSearchX /> : <MdAddBox />}
                </Link>
                <p>
                  {productNotFound
                    ? productNotFound
                    : "Hey! Let's add your first product!"}
                </p>
              </div>
            )}
            {products.length > 0 && (
              <div
                className={`product-items ${listStyle}-style`}
                onScroll={handleScroll}
              >
                {products.map((item, i) => {
                  const exists = selectedArray?.find((el) => el === item?.id);
                  const selected = exists ? true : false;
                  if (products?.length - 1 === i) {
                    return (
                      <div
                        className={`load-next`}
                        style={{ width: "100%" }}
                        ref={lastProductRef}
                        key={i}
                        onMouseDown={() => {
                          handleMouseDown(item);
                        }}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp}
                        onTouchStart={() => {
                          handleMouseDown(item, true);
                        }}
                        onTouchEnd={handleMouseUp}
                        onTouchCancel={handleMouseUp}
                      >
                        <ProductItem
                          className={`${
                            selectedProduct?.id === item?.id
                              ? "highlight-selected-item"
                              : ""
                          }`}
                          multiSelected={selected}
                          item={item}
                          currency={currency}
                          handleClick={() => {
                            if (allowMultipleSelect) {
                            } else {
                              if (currentViewPort === "mobile") {
                                navigate(ROUTES.editProduct.path, {
                                  state: { editData: item },
                                });
                              } else {
                                setSelectedProduct(item);
                                setOpenAddCategory(false);
                                setSelectedTab("editProduct");
                              }
                            }
                          }}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className={`${
                          selectedProduct?.id === item?.id
                            ? "highlight-selected-item"
                            : ""
                        }`}
                        style={{ width: "100%" }}
                        key={i}
                        onMouseDown={() => {
                          handleMouseDown(item);
                        }}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp}
                        onTouchStart={() => {
                          handleMouseDown(item, true);
                        }}
                        onTouchEnd={handleMouseUp}
                        onTouchCancel={handleMouseUp}
                      >
                        <ProductItem
                          className={`${
                            selectedProduct?.id === item?.id
                              ? "highlight-selected-item"
                              : ""
                          }`}
                          multiSelected={selected}
                          item={item}
                          currency={currency}
                          handleClick={() => {
                            if (allowMultipleSelect) {
                            } else {
                              if (currentViewPort === "mobile") {
                                navigate(ROUTES.editProduct.path, {
                                  state: { editData: item },
                                });
                              } else {
                                setSelectedProduct(item);
                                setOpenAddCategory(false);
                                setSelectedTab("editProduct");
                              }
                            }
                          }}
                          key={i}
                        />
                      </div>
                    );
                  }
                })}
                {loadingNextPage && (
                  <div className="product-loading-item">
                    <div className="image"></div>
                    <div className="content">
                      <div className="details">
                        <div className="name"></div>
                        <div className="stock"></div>
                      </div>
                      <div className="price"></div>
                    </div>
                  </div>
                )}
                <div
                  className="desktop-product-item"
                  onClick={() => {
                    setOpenAddCategory(false);
                    setSelectedTab("addProduct");
                    setSelectedProduct(null);
                  }}
                >
                  <FaPlus />
                </div>
              </div>
            )}
          </div>

          <AddCategory
            openAddCategory={openAddCategory}
            setOpenAddCategory={setOpenAddCategory}
            organizationId={organization_id}
          />

          <ImportField
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />

          <DeleteMultipleModel
            open={openDelete}
            setOpen={setOpenDelete}
            selectedList={selectedArray}
            setSelectedList={setSelectedArray}
            organizationId={organization_id}
          />

          {(openAddCategory || openDelete) && (
            <div
              className={`blur-back ${openDelete ? "desktop" : ""}`}
              onClick={() => {
                setOpenAddCategory(false);
                setOpenDelete(false);
              }}
            ></div>
          )}

          {selectedArray?.length && (
            <div className="floating-button">
              <CustomButton
                name={`Delete ${selectedArray?.length} Items`}
                type={"button"}
                color={"danger"}
                bigButton={true}
                handleSubmit={() => {
                  if (userIsAllowedToDeleteProduct) {
                    setOpenDelete(true);
                  } else {
                    toast.dismiss();
                    toast.info(
                      "You do not have sufficient permissions to perform this action. Please contact your administrator."
                    );
                  }
                }}
                disabled={selectedArray?.length === 0}
              />
            </div>
          )}

          {products?.length > 0 && orgIsAllowedToManageStock && (
            <div
              className={`total-products-worth ${
                isScrolling ? "inactive" : ""
              }`}
            >
              <p>
                {worthData?.total || 0} worth {currency}
                {worthData?.worth}
              </p>
            </div>
          )}
          <div className="open-scanner-icon">
            <p className="sort">
              Sort by {sortOptions?.find((el) => el.value === sortBy)?.label}
              <FaCaretUp
                className={sort === "desc" ? "opposite" : ""}
              />
            </p>
            <BsThreeDotsVertical
              onClick={() => {
                setOpenSortOptions((pre) => !pre);
              }}
            />
          </div>
        </div>

        <div className="right-desktop-view">
          <div className="desktop-navbar">
            <p>
              {selectedProduct
                ? ROUTES.editProduct.title
                : ROUTES.addProduct.title}
            </p>
          </div>
          {selectedProduct ? (
            <AddProduct
              isEdit={true}
              desktopView={true}
              item={selectedProduct}
              setSelectedProduct={setSelectedProduct}
            />
          ) : (
            <AddProduct desktopView={true} />
          )}
        </div>
      </div>
    </>
  );
};

export default ManageProduct;

const AddCategory = ({
  openAddCategory,
  setOpenAddCategory,
  organizationId,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const clearForm = () => {
    reset({
      name: "",
      description: "",
    });
  };

  const handleAddCategory = (data) => {
    setSubmitting(true);
    const categoryData = {
      organization_id: organizationId,
      name: data.name,
      description: data.description,
    };

    addCategory(categoryData)
      .then((res) => {
        toast.dismiss();
        toast.success("Category added successfully.");
        dispatch(addNewCategory({ category: res.data }));
        setOpenAddCategory(false);
        clearForm();
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          if (err?.response?.data?.message === "User not authorized!") {
            toast.dismiss();
            toast.error(
              "You do not have sufficient permissions to perform this action. Please contact your administrator."
            );
          } else {
            toast.dismiss();
            toast.error(`${err?.response?.data?.message}`);
          }
        } else {
          toast.dismiss();
          toast.error("Category adding failed.");
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (openAddCategory) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [openAddCategory, isVisible]);

  if (!shouldRender) return null;

  return (
    <form
      disabled={submitting}
      onSubmit={handleSubmit(handleAddCategory)}
      className={`add-category ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">Add Category</h1>

      <div className="form-content">
        <InputField
          name={"name"}
          type={"text"}
          label={"Category Name"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
        />

        <InputField
          name={"description"}
          type={"text"}
          label={"Description"}
          required={false}
          textArea={true}
          register={register}
          inputErrors={errors}
          watch={watch}
        />
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpenAddCategory(false);
            clearForm();
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Save"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={submitting}
          loader={submitting}
        />
      </div>
    </form>
  );
};

const ImportField = ({ selectedTab, setSelectedTab }) => {
  const navigate = useNavigate();
  const fileRef = useRef();
  const [file, setFile] = useState("");

  const handleFileChange = (e) => {
    const fileData = e.target.files[0];
    if (fileData) {
      setFile(fileData);
    }
  };

  useEffect(() => {
    if (file) {
      Papa.parse(file, {
        header: false,
        complete: async (results) => {
          const products = results?.data;
          navigate(ROUTES.productsImport.path, {
            state: {
              csvData: products,
            },
          });
        },
        skipEmptyLines: true,
      });
    } else {
      if (fileRef) {
        fileRef.current.value = "";
      }
    }
  }, [file]);

  const handleCancel = () => {
    if (fileRef) {
      fileRef.current.value = "";
    }
    setSelectedTab("");
    setFile(null);
  };

  return (
    <div
      className={`upload-exports ${selectedTab === "import" ? "active" : ""}`}
    >
      <div className="inputs">
        <input
          ref={fileRef}
          type="file"
          onChange={handleFileChange}
          accept=".csv"
        />
        <FiDownload />
        <p>{file ? "File selected" : "Choose your files"}</p>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel Import"}
          color={"danger"}
          type={"button"}
          handleSubmit={handleCancel}
          disabled={false}
        />

        <CustomButton
          name={"Import CSV"}
          color={"primary"}
          type={"button"}
          handleSubmit={() => {}}
          disabled={!file}
        />
      </div>
    </div>
  );
};

const DeleteMultipleModel = ({
  open,
  setOpen,
  selectedList,
  setSelectedList,
  organizationId,
}) => {
  const [deleting, setDeleting] = useState(false);
  const dispatch = useDispatch();
  const orgIsAllowedToBulkDelete = useOrganizationIsAllowed("bulk_delete");

  const handleDelete = () => {
    if (orgIsAllowedToBulkDelete.exists) {
      setDeleting(true);

      const data = {
        products: selectedList,
        organization_id: organizationId,
      };

      deleteMultipleProducts(data)
        .then((res) => {
          selectedList?.forEach((el) => {
            dispatch(deleteExistingProduct({ product_id: el }));
          });
          toast.dismiss();
          toast.success("Products deleted successfully.");
          setOpen(false);
          setSelectedList([]);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss();
              toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss();
              toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss();
            toast.error("Error while deleting product.");
          }
        })
        .finally(() => {
          setDeleting(false);
        });
    } else {
      dispatch(updateOpenSubscriptionAd({ openAd: true }));
    }
  };

  useEffect(() => {
    if (open) {
      if (selectedList?.length === 0) {
        setOpen(false);
      }
    }
  }, [selectedList, open]);

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`confirm-delete-model ${isVisible ? "active" : ""}`}>
      <p className="title">Multiple Products Delete Confirmation</p>

      <div className="confirm-container">
        <img src="/images/warning.svg" alt="" aria-label="Warning" />
        <p>
          Are you sure you want to <span>DELETE</span> these selected products?{" "}
          <br /> Once deleted, these products and its related data cannot be
          recovered back.
        </p>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={deleting}
        />

        <CustomButton
          name={"Yes, Delete"}
          color={"primary"}
          type={"button"}
          handleSubmit={handleDelete}
          disabled={deleting}
          loader={deleting}
        />
      </div>
    </div>
  );
};
